<template>
    <div style="float: left">
        <b-button class="float-sm-left btn-toolbar sa-btn-icon-text" variant="outline-secondary sa-margin-left" size="sm" @click="onFirma" :disabled="disabled">
            <b-icon icon="vector-pen"></b-icon>
            Firma Multipla
        </b-button>
        <b-modal ref="mdlFirma" title="Firma" @hidden="onHidden" @ok="onOk">
            <form ref="form" @submit.stop.prevent="onFirmaSubmit">
                <b-form-group label="Password" label-for="name-input" invalid-feedback="Name is required" :state="passwordState">
                    <b-form-input type="password" v-model="password" :state="passwordState" required placeholder="Password"></b-form-input>
                </b-form-group>
            </form>
        </b-modal>
    </div>
</template>
<script>
import axios from "axios";
export default {
    props: {
        idEvento: { type: String, require: true },
        pathRestFirma: { type: String, require: true },
        pathRestValidation: { type: String, require: true },
        disabled: { type: Boolean, require: true, default: false },
        fieldName: { type: String, require: true },
        data: { Type: Array, require: true },
        firmaData: {
            Type: Array,
            default: function() {
                // return [{ idEvento: this.idEvento, key: null, fieldName: this.fieldName }];
                return [];
            },
        },
    },
    data() {
        return {
            password: "",
            passwordState: null,
        };
    },
    methods: {
        checkFormValidity() {
            const valid = this.$refs.form.checkValidity();
            this.passwordState = valid;
            return valid;
        },
        onFirma() {
            let me = this;
            let validation = true;
            let validationMessage = "";
            console.log(me.data);
            me.data.forEach((element) => {
                if (me.idEvento === "-1" || element.id === null) {
                    validation = false;
                    validationMessage = "Ci sono esami non salvati, impossibile effettuare la validazione.";
                } else {
                    let elemento = { idEvento: element.id, key: null, fieldName: this.fieldName };
                    this.firmaData.push(elemento);
                }
            });

            if (validation) {
                me.firma();
            } else {
                this.$bvModal
                    .msgBoxOk(validationMessage, {
                        title: "ATTENZIONE",
                        size: "sm",
                        okVariant: "outline-danger",
                        headerClass: "sa-msg-header-danger",
                        footerClass: "p-2 border-top-0",
                        centered: true,
                    })
                    .then((value) => {
                        this.boxOne = value;
                    });
            }
        },
        firma() {
            let me = this;
            let jsonData = JSON.stringify(me.data);
            console.log(jsonData);
            let link = process.env.VUE_APP_PATH_API + me.pathRestFirma + me.pathRestValidation;
            axios
                .post(link, jsonData)
                .then(() => {
                    me.$refs["mdlFirma"].show();
                })
                .catch((e) => {
                    console.log(e.response.status);
                    let message = "";
                    if (e.response.data.messaggio) {
                        message = e.response.data.messaggio;
                    } else {
                        message = e.response.status;
                    }
                    this.$bvModal.msgBoxOk(message, {
                        title: "ATTENZIONE",
                        size: "sm",
                        okVariant: "outline-danger",
                        headerClass: "sa-msg-header-danger",
                        footerClass: "p-2 border-top-0",
                        centered: true,
                    });
                });
        },
        onFirmaSubmit() {
            // Exit when the form isn't valid
            let me = this;
            if (!this.checkFormValidity()) {
                return;
            }
            let key = btoa(btoa(this.password));
            me.firmaData.forEach((element) => {
                element.key = key;
            });
            // this.firmaData.key = key;
            let jsonData = JSON.stringify(this.firmaData);
            console.log(jsonData);
            let link = process.env.VUE_APP_PATH_API + this.pathRestFirma + "/firma";
            axios
                .post(link, jsonData)
                .then((response) => {
                    let me = this;
                    console.log(response);
                    me.$emit("update");
                    this.$bvToast.toast(response.data.messaggio, {
                        title: "Firma effettuata",
                        variant: "success",
                        solid: true,
                        noCloseButton: true,
                        autoHideDelay: 2000,
                    });
                })
                .catch((err) => {
                    this.$bvModal
                        .msgBoxOk(err.response.data.messaggio, {
                            title: "ATTENZIONE",
                            size: "sm",
                            okVariant: "outline-danger",
                            headerClass: "sa-msg-header-danger",
                            footerClass: "p-2 border-top-0",
                            centered: true,
                        })
                        .then((value) => {
                            this.boxOne = value;
                        });
                });

            this.$nextTick(() => {
                this.$refs["mdlFirma"].hide();
            });
        },
        onHidden() {
            this.passwordState = null;
            this.password = "";
        },
        onOk(bvModalEvt) {
            let me = this;
            bvModalEvt.preventDefault();
            me.onFirmaSubmit();
        },
    },
};
</script>
